import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import MukemelLogo from "./../../assets/headernewllogo.png";
import bagIcon from "./../../assets/shopnew.png";
import NavSearch from "../NavSearch/NavSearch";
import searchIcon from "./../../assets/searchnew.png";
import menuIcon from "./../../assets/hamburgernew.png";
import loveIcon from "./../../assets/heartnew.png";
import userIcon from "./../../assets/usersnew.png";
import LanguageSelector from "./../../components/LanguageSelector/LanguageSelector.js";
import { useTranslation } from "react-i18next";
import OffcanvasMenu from "./../../components/OffcanvasMenu/OffcanvasMenu";
import { PriceFormatProvider } from "./../../components/PriceFormat/PriceFormat";

const Header = () => {
  const { t } = useTranslation();
  const userId = sessionStorage.getItem("user_id");

  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  //menu
  const [menuOpen, setMenuOpen] = useState(false);

  // Sepet sayısını ve favori sayısını güncelleme
  useEffect(() => {
    // localStorage'daki eski verileri temizleyelim
    // localStorage.removeItem("cart"); // Sepet verisini sıfırlayalım
    // localStorage.removeItem("wishlistItems"); // Wishlist verisini sıfırlayalım

    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      setCartCount(
        cart.reduce((total, item) => total + (item.quantity || 1), 0)
      );
    };

    const updateWishlistCount = () => {
      const wishlist = JSON.parse(localStorage.getItem("wishlistItems")) || [];
      const validWishlist = wishlist.filter(
        (item) => item !== null && item !== undefined && item !== ""
      );
      const validWishlistCount = validWishlist.length;
      setWishlistCount(validWishlistCount);
    };

    // İlk yüklemede sepet ve favori sayacını güncelle
    updateCartCount();
    updateWishlistCount();

    // Event listeners to update cart and wishlist count
    window.addEventListener("cartUpdated", updateCartCount);
    window.addEventListener("wishlistUpdated", updateWishlistCount);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("cartUpdated", updateCartCount);
      window.removeEventListener("wishlistUpdated", updateWishlistCount);
    };
  }, []); // Yalnızca ilk yükleme sırasında çalışacak şekilde boş dizi

  // Wishlist sayfasına tıklama
  const handleWishlistClick = () => {
    window.dispatchEvent(new Event("wishlistUpdated"));
  };

  return (
    <>
      <header className="headerbgcolor py-3 d-none d-lg-block d-md-block">
        <div className="container-fluid px-4 pe-4">
          <div className="row align-items-center">
            <div className="col-4">
              <nav>
                <ul className="list-unstyled d-flex align-items-center mb-0 gap-3">
                  <li className="d-flex align-items-center">
                    <LanguageSelector />
                  </li>
                  <li>
                    <Link
                      className="text-decoration-none linktext headertitle300 fw-14 d-flex align-items-center"
                      onClick={() => setMenuOpen(true)}
                    >
                      <img
                        src={menuIcon}
                        alt="Menü"
                        className="me-2"
                        width="17"
                      />
                      {t("Menu")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="./"
                      className="text-decoration-none linktext headertitle300 fw-14 d-flex align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#searchModal"
                    >
                      <img
                        src={searchIcon}
                        alt="Arama"
                        className="me-2"
                        width="17"
                      />
                      {t("Arama")}
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="col-4 text-center">
              <Link to="/" className="text-decoration-none text-dark">
                <img src={MukemelLogo} alt="Mükemel" width={100} />
              </Link>
            </div>

            <div className="col-4 text-end mt-2">
              <Link
                to="/wishlist"
                className="headertitle300 text-dark text-decoration-none fw-14 cart-icon2"
                onClick={handleWishlistClick} // Güncellemeyi tetikle
              >
                <img
                  src={loveIcon}
                  className="mx-3"
                  alt="Favori Listesi"
                  width={17}
                />
                <span className="cart-counter2">{wishlistCount}</span>
              </Link>

              {userId ? (
                <Link
                  to={`/profile/${userId}`}
                  className="headertitle300 text-dark text-decoration-none fw-14"
                >
                  <img src={userIcon} alt="Profil" width={18} />
                </Link>
              ) : (
                <Link
                  to="/userlogin"
                  className="headertitle300 text-dark text-decoration-none fw-14"
                >
                  <img src={userIcon} alt="Kullanıcı Girişi" width={18} />
                </Link>
              )}

              <Link
                to="/cart"
                className="text-dark text-decoration-none cart-icon"
              >
                <img src={bagIcon} width={20} alt="Sepet" className=" mx-3" />
                <span className="cart-counter">{cartCount}</span>
              </Link>
            </div>
          </div>
        </div>
      </header>

      <header className="headerbgcolor py-3 d-md-none">
        <div className="container-fluid px-4">
          <div className="d-flex justify-content-between align-items-center position-relative">
            {/* Sol: Dil seçici */}
            <div className="d-flex align-items-center">
              <LanguageSelector />
            </div>

            {/* Orta: Logo - mutlak konumla tam ortada */}
            <div className="position-absolute top-50 start-50 translate-middle">
              <Link to="/" className="text-decoration-none text-dark">
                <img
                  src={MukemelLogo}
                  alt="Mükemel"
                  width={90}
                  loading="lazy"
                />
              </Link>
            </div>

            {/* Sağ: Menü ikonu */}
            <div>
              <Link
                to="./"
                onClick={() => setMenuOpen(true)}
                className="text-decoration-none text-dark"
              >
                <i className="fa-solid fa-bars fa-lg wbtextcolor2"></i>
              </Link>
            </div>
          </div>
        </div>
      </header>

      <header className="d-block d-sm-block d-md-none">
        <nav className="navbar navbar-light wbbgcolor custom-border fixed-bottom d-flex justify-content-around pt-3 pb-0">
          <Link
            to="/"
            className="text-decoration-none linktext headertitle300 fw-14 text-center"
            data-bs-toggle="modal"
            data-bs-target="#searchModal"
          >
            <img src={searchIcon} alt="Arama" className="me-2" width="17" />
            <p className="mt-1">{t("Arama")}</p>
          </Link>

          {userId ? (
            <Link
              to={`/profile/${userId}`}
              className="headertitle300 text-dark text-decoration-none fw-14 text-center"
            >
              <i className="far fa-user fa-lg wbtextcolor2"></i>
              <p className="linktext mt-1">{t("Profil")}</p>
            </Link>
          ) : (
            <Link
              to="/userlogin"
              className="headertitle300 text-dark text-decoration-none fw-14 text-center"
            >
              <i className="far fa-user fa-lg wbtextcolor2"></i>
              <p className="linktext mt-1">{t("Profil")}</p>
            </Link>
          )}
          <Link
            to="/cart"
            className="text-dark text-decoration-none cart-icon text-center"
          >
            <img
              src={bagIcon}
              width={20}
              alt="Sepet"
              className="margintop6 mx-3"
              loading="lazy"
            />
            <span className="cart-counter">{cartCount}</span>
            <p className="linktext mt-1">{t("Sepet")}</p>
          </Link>
          <Link
            to="/wishlist"
            className="headertitle300 text-dark text-decoration-none fw-14 cart-icon2"
            onClick={handleWishlistClick} // Güncellemeyi tetikle
          >
            <img
              src={loveIcon}
              className="mx-3"
              alt="Favori Listesi"
              width={17}
            />
            <span className="cart-counter2">{wishlistCount}</span>
            <p className="linktext mt-1">{t("FavoriList")}</p>
          </Link>
        </nav>
      </header>
      <PriceFormatProvider>
        <NavSearch />
      </PriceFormatProvider>

      <OffcanvasMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
};

export default Header;
